<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <strong v-text="$lang.edit_question_suggest"></strong>
      </div>
      <div v-if="isLoading" class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <!-- @handleBack="handleBack" -->
      <interviewDoingForm
        mode="edit"
        :permissions="permissions"
        v-if="!isLoading && Object.keys(this.item).length > 0"
        :item="item"
        @cancel="handleBack"
        @submit="save"
      />
    </b-card>
  </div>
</template>

<script>
import interviewDoingForm from "./../forms/interviewDoingForm";
export default {
  components: {
    interviewDoingForm,
  },
  inject: ["questionSuggestRepository", "questionSuggestEvaluationRepository"],
  data() {
    return {
      id: this.$route.params.id,
      item: {},
      isLoading: false,
      permissions: [],
      openText: false,
    };
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },

    async save(payload) {
      try {
        this.isLoading = true;
        let response = null;
        if (this.permissions.includes(`admin`))
          response = await this.questionSuggestEvaluationRepository.edit(
            this.id,
            payload
          );
        else
          response = await this.questionSuggestRepository.edit(
            this.id,
            payload
          );
        this.$notify.success(response.data.message);
        this.$router.push({
          name: "questionSuggest",
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.questionSuggestRepository.find(this.id);

        this.item = response.data.data;
        this.permissions = response.data.permissions;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
